export var IFsFileType;
(function (IFsFileType) {
    IFsFileType["Unknown"] = "unknown";
    IFsFileType["Image"] = "image";
    IFsFileType["Image360"] = "image360";
    IFsFileType["Video"] = "video";
    IFsFileType["Video360"] = "video360";
    IFsFileType["Audio"] = "audio";
    IFsFileType["Model3d"] = "model3d";
    IFsFileType["ImageTarget"] = "imagetarget";
})(IFsFileType || (IFsFileType = {}));
